export enum SUPPORT_CHAT_SEARCH_PARAMS {
  SHOW_SUPPORT_CHAT = "showSupportChat",
  CHAT_SUPPORT_MESSAGE = "chatSupportMessage",
}
